import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command";
import { COURSE } from "../data/course";
import { BookOpen, FileText } from "lucide-react";

export default function GlobalSearch({ open, onOpenChange }) {
  const nav = useNavigate();

  const items = useMemo(() => {
    const arr = [];
    COURSE.modules.forEach((m) => {
      arr.push({
        type: "module",
        moduleId: m.id,
        label: `Module ${m.number}: ${m.title}`,
        hint: m.tagline,
      });
      m.subTopics.forEach((s) => {
        arr.push({
          type: "sub",
          moduleId: m.id,
          subId: s.id,
          label: s.title,
          hint: `Module ${m.number}: ${m.title}`,
        });
      });
    });
    return arr;
  }, []);

  const go = (item) => {
    onOpenChange(false);
    if (item.type === "module") {
      nav(`/module/${item.moduleId}`);
    } else {
      nav(`/module/${item.moduleId}?sub=${item.subId}`);
    }
  };

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput placeholder="Search modules, subtopics, concepts…" data-testid="search-input" />
      <CommandList>
        <CommandEmpty>No results found.</CommandEmpty>
        <CommandGroup heading="Modules">
          {items
            .filter((i) => i.type === "module")
            .map((i) => (
              <CommandItem
                key={i.moduleId}
                onSelect={() => go(i)}
                data-testid={`search-item-${i.moduleId}`}
                value={`${i.label} ${i.hint}`}
              >
                <BookOpen className="w-4 h-4 mr-2 text-primary" />
                <div className="flex flex-col">
                  <span>{i.label}</span>
                  <span className="text-xs text-muted-foreground">{i.hint}</span>
                </div>
              </CommandItem>
            ))}
        </CommandGroup>
        <CommandGroup heading="Subtopics">
          {items
            .filter((i) => i.type === "sub")
            .map((i) => (
              <CommandItem
                key={i.subId}
                onSelect={() => go(i)}
                data-testid={`search-item-${i.subId}`}
                value={`${i.label} ${i.hint}`}
              >
                <FileText className="w-4 h-4 mr-2 text-accent" />
                <div className="flex flex-col">
                  <span>{i.label}</span>
                  <span className="text-xs text-muted-foreground">{i.hint}</span>
                </div>
              </CommandItem>
            ))}
        </CommandGroup>
      </CommandList>
    </CommandDialog>
  );
}
